import React from 'react'
import graphql from 'babel-plugin-relay/macro'
import { fetchQuery } from 'config/amber-relay'
import Select from 'components/v2/Select'

export default function BrandSelect(props) {
  const fetch = async (where) => {
    const { brands } = await fetchQuery(
      graphql`
        query BrandSelectQuery($where: BrandWhere) {
          brands(where: $where, first: 10, orderBy: [name], order: ASC) {
            edges {
              node {
                id
                name
              }
            }
          }
        }
      `,
      { where }
    )

    const getText = (node) => {
      return ` ${node.name}`
    }

    return brands.edges.map(({ node }) => ({
      key: node.id,
      value: node.id,
      text: getText(node)
    }))
  }

  return (
    <Select
      {...props}
      getByValue={(value) => fetch({ id: { eq: value } })}
      loadOptions={(searchQuery) => fetch({ name: { iLike: `%${searchQuery}%` } })}
    />
  )
}

BrandSelect.defaultProps = {
  label: 'Marca',
  placeholder: 'Marca',
  loadOnMount: false,
}